import { Pipe, PipeTransform } from '@angular/core';
import { IZoomMeeting, ZoomService } from './Zoom.Service';

@Pipe({ name: 'zoomMeetingFormat',
	standalone: false
})
export class ZoomMeetingFormatPipe implements PipeTransform {

	constructor(
		public ZoomService: ZoomService
	) {}


	public transform(meeting: IZoomMeeting): string {
		return this.ZoomService.formatMeeting(meeting);
	}
}
